import React from 'react';
import Select from 'react-select';
import styles from '../HomePageForm/HomePageForm.module.sass';
import useSchools from '../../hooks/useSchools';

export default function AdminSchoolInput({ school }) {
  const schools = useSchools()
  const schoolHandler = (opt) => window.location = `${window.location.pathname}?school_id=${opt.value}`;

  return (
    <Select
      id="school-input"
      defaultValue={school}
      options={[{ id: 'all', name: 'All' }, ...schools].map((selectSchool) => (
        ({ value: selectSchool.id, label: selectSchool.name })
      ))}
      className={styles.schoolInput}
      onChange={schoolHandler}
    />
  )
};
